import styled from "@emotion/styled";
import { UiTheme } from "@nykaa/payment-ui/src/@types";
import { getHexToRgba } from "@nykaa/payment-ui/src/common/helpers/getHexToRgba";


export const RetryWalletLayout = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  border-radius: 8px;
  border: 1px solid ${({ theme }: UiTheme) => getHexToRgba(theme?.colors?.textPrimary, 0.08)};
  .retry-heading {
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      margin-right: 8px;
    }
  }
  button {
    width: unset;
  }
`;

export const RetryWalletWrapper = styled.div`
  
`;
